"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeCosts = computeCosts;
const retrocession_cost_1 = require("./retrocession-cost");
const round_retrocession_cost_1 = require("./round/round-retrocession-cost");
const shipping_cost_1 = require("./shipping-cost");
function computeCosts(param) {
    const shippingCost = (0, shipping_cost_1.computeShippingCost)(param.vatRate, param.shippingCostWithoutDiscount, param.shippingDiscount, param.lines);
    if (!param.transporter)
        return {
            totalCosts: { shipping: shippingCost.totalCost },
            linesCosts: shippingCost.costPerLine.map(line => ({ lineId: line.lineId, costs: { shipping: line.cost } }))
        };
    const preparationCost = param.transporter.preparationFeesSchedule
        ? (0, round_retrocession_cost_1.roundRetrocedingCost)((0, retrocession_cost_1.computeRetrocessionCosts)({
            ...param,
            feesSchedule: param.transporter.preparationFeesSchedule
        }))
        : undefined;
    const transportCost = param.transporter.transportFeesSchedule
        ? (0, round_retrocession_cost_1.roundRetrocedingCost)((0, retrocession_cost_1.computeRetrocessionCosts)({
            ...param,
            feesSchedule: param.transporter.transportFeesSchedule
        }))
        : undefined;
    return {
        totalCosts: {
            preparation: preparationCost === null || preparationCost === void 0 ? void 0 : preparationCost.totalCost,
            shipping: shippingCost.totalCost,
            transport: transportCost === null || transportCost === void 0 ? void 0 : transportCost.totalCost
        },
        linesCosts: param.lines.map(line => ({
            costs: {
                preparation: preparationCost ? getLineCost(preparationCost.costPerLine, line) : undefined,
                shipping: getLineCost(shippingCost.costPerLine, line),
                transport: transportCost ? getLineCost(transportCost.costPerLine, line) : undefined
            },
            lineId: line.lineId
        }))
    };
}
function getLineCost(costPerLine, line) {
    var _a;
    return (_a = costPerLine.find(costLine => costLine.lineId === line.lineId)) === null || _a === void 0 ? void 0 : _a.cost;
}
